(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .factory('dashboardStoreService', dashboardStoreService);

  dashboardStoreService.$inject = ['$cookies'];

  function dashboardStoreService($cookies) {
    var COOKIE_NAME = 'trainee_cModule_selection';
    var store = {};

    var service = {
      save: save,
      read: read
    };

    return service;

    //////////////

    function save(key, value) {
      store[key] = value;
      saveCookie();
    }

    function read(key) {
      loadCookie();
      return store[key];
    }

    function saveCookie() {
      $cookies.putObject(COOKIE_NAME, store);
    }

    function loadCookie() {
      var val = $cookies.getObject(COOKIE_NAME);
      if (!val) {
        return;
      }
      store = val;
    }

  }

})();
